function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { Dropdown, Input } from '@nackle/paper';
import CompanyService from '../../services/company';
import SolutionService from '../../services/solution';
import { brandingURL } from '../../endpoints';
import './company-select.less';
export default class CompanySelect extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      companies: [],
      recentCompanies: [],
      selectedCompany: null,
      selectedCompanyLoaded: false,
      solution: null,
      branding: null,
      dropdownVisible: false,
      companyStyles: null
    });
    _defineProperty(this, "handleDropDownVisibleChange", visible => {
      this.setState({
        dropdownVisible: visible
      }, () => {
        if (visible) {
          setTimeout(() => {
            document.getElementById('companySelectInput').focus();
          }, 333);
        }
      });
    });
    _defineProperty(this, "handleCompanyChange", company => {
      const {
        onChange
      } = this.props;
      if (typeof onChange === 'function') {
        onChange(company);
      }
      this.setState({
        filter: '',
        dropdownVisible: false
      });
    });
    _defineProperty(this, "loadCompanies", async () => {
      const {
        auth
      } = this.props;
      try {
        const companyService = new CompanyService(auth.state);
        const companies = await companyService.listCompanies();
        const recentCompanies = getRecentCompanies(companies);
        this.setState({
          companies,
          recentCompanies
        });
      } catch (error) {
        console.error(error);
        this.setState({
          companies: [],
          recentCompanies: []
        });
      }
    });
    _defineProperty(this, "loadSolutionAndBranding", async () => {
      const {
        auth
      } = this.props;
      try {
        const solutionService = new SolutionService(auth.state);
        const solution = await solutionService.getSolution();
        this.setState({
          selectedCompanyLoaded: true,
          solution
        });
      } catch (error) {
        console.error(error);
        this.setState({
          selectedCompanyLoaded: true
        });
      }
    });
  }
  static getDerivedStateFromProps(props, state) {
    var _state$selectedCompan;
    if (props.companyId === ((_state$selectedCompan = state.selectedCompany) === null || _state$selectedCompan === void 0 ? void 0 : _state$selectedCompan.id)) {
      return null;
    }
    if (!props.companyId && !state.selectedCompany) {
      return null;
    }
    if (!props.companyId && state.selectedCompany) {
      return {
        selectedCompany: null
      };
    }
    const selectedCompany = state.companies.find(c => c.id === props.companyId);
    if (selectedCompany) {
      saveToRecentCompanies(selectedCompany);
      return {
        selectedCompany,
        selectedCompanyLoaded: false,
        solution: null,
        branding: false,
        recentCompanies: getRecentCompanies(state.companies)
      };
    }
    return {
      selectedCompany: null
    };
  }
  componentDidMount() {
    this.loadCompanies();
  }
  componentDidUpdate() {
    const {
      selectedCompany,
      selectedCompanyLoaded
    } = this.state;
    if (selectedCompany && !selectedCompanyLoaded) {
      this.loadSolutionAndBranding();
    }
  }
  render() {
    const {
      companies,
      recentCompanies,
      selectedCompany,
      solution,
      dropdownVisible
    } = this.state;
    const {
      companySelectDisabled
    } = this.props;
    return /*#__PURE__*/React.createElement(Dropdown, {
      visible: dropdownVisible,
      onVisibleChange: this.handleDropDownVisibleChange,
      overlay: /*#__PURE__*/React.createElement(CompanySelectMenu, {
        companies: companies,
        recentCompanies: recentCompanies,
        onChange: this.handleCompanyChange
      }),
      trigger: ['click'],
      disabled: companySelectDisabled
    }, /*#__PURE__*/React.createElement("div", {
      className: "company-select",
      onClick: this.handleSelectClick
    }, selectedCompany ? /*#__PURE__*/React.createElement(Fragment, null, selectedCompany ? /*#__PURE__*/React.createElement("img", {
      className: "company-select-logo",
      src: `${brandingURL}/companies/${selectedCompany.id}/logos/primary`
    }) : /*#__PURE__*/React.createElement("span", {
      className: "company-select-logo-placeholder"
    }), /*#__PURE__*/React.createElement("div", {
      className: "company-select-name-container"
    }, /*#__PURE__*/React.createElement("span", {
      className: "company-select-name"
    }, selectedCompany.name), /*#__PURE__*/React.createElement("span", {
      className: "company-select-solution"
    }, solution ? solution.name : '', "\xA0"))) : /*#__PURE__*/React.createElement("span", {
      className: "placeholder"
    }, "select a company..."), /*#__PURE__*/React.createElement(DownIcon, {
      className: "down"
    })));
  }
}
function saveToRecentCompanies(company) {
  if (!localStorage) {
    return;
  }
  let recentCompanies = localStorage.getItem('recent-companies');
  if (recentCompanies) {
    recentCompanies = JSON.parse(recentCompanies);
  } else {
    recentCompanies = [];
  }

  // remove the current company, and limit it to the last 4
  recentCompanies = recentCompanies.filter(companyId => companyId !== company.id).filter((companyId, index) => index < 4);
  localStorage.setItem('recent-companies', JSON.stringify([company.id, ...recentCompanies]));
}
function getRecentCompanies(allCompanies) {
  if (!localStorage) {
    return [];
  }
  let recentCompanies = localStorage.getItem('recent-companies');
  if (recentCompanies) {
    recentCompanies = JSON.parse(recentCompanies);
  } else {
    recentCompanies = [];
  }
  return recentCompanies.map(companyId => allCompanies.find(company => companyId === company.id)).filter(company => !!company);
}
const DownIcon = ({
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.544 6.044l-9.544 9.541-9.544-9.541-1.416 1.416 10.25 10.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l10.25-10.25-1.409-1.416z"
}));
class CompanySelectMenu extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      filter: '',
      filteredCompanies: []
    });
    _defineProperty(this, "handleFilterChange", e => {
      const {
        companies
      } = this.props;
      const filter = e.target.value;
      this.setState({
        filter,
        filteredCompanies: filter ? companies.filter(company => company.name.toLowerCase().includes(filter.toLowerCase())) : []
      });
    });
    _defineProperty(this, "handleFilterKeyUp", e => {
      const {
        filter,
        filteredCompanies
      } = this.state;
      if (e.keyCode === 13) {
        if (filter && filteredCompanies.length == 1) {
          this.handleCompanyClick(filteredCompanies[0])(e);
        }
      } else if (e.keyCode === 27) {
        this.handleSelectClick();
      }
    });
    _defineProperty(this, "handleCompanyClick", company => () => {
      const {
        onChange
      } = this.props;
      if (typeof onChange === 'function') {
        onChange(company);
      }
      this.setState({
        filter: ''
      });
    });
  }
  render() {
    const {
      filter,
      filteredCompanies
    } = this.state;
    const {
      companies,
      recentCompanies
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "company-select-menu"
    }, /*#__PURE__*/React.createElement(Input, {
      autoFocus: true,
      id: "companySelectInput",
      className: "company-select-filter",
      placeholder: "search companies...",
      value: filter,
      onKeyUp: this.handleFilterKeyUp,
      onChange: this.handleFilterChange,
      size: "large",
      autoComplete: "off",
      allowClear: true
    }), /*#__PURE__*/React.createElement("div", {
      className: "company-select-list-container"
    }, filter ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", {
      className: "company-select-header"
    }, "Search Results"), this.renderCompanyList(filteredCompanies)) : /*#__PURE__*/React.createElement(Fragment, null, recentCompanies.length > 0 && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", {
      className: "company-select-header"
    }, "Recent Companies"), this.renderCompanyList(recentCompanies)), /*#__PURE__*/React.createElement("h2", {
      className: "company-select-header"
    }, "All Companies"), this.renderCompanyList(companies))));
  }
  renderCompanyList(companies) {
    return /*#__PURE__*/React.createElement("ul", {
      className: "company-select-list"
    }, companies.map(company => /*#__PURE__*/React.createElement("li", {
      key: company.id,
      className: "company-select-list-item",
      onClick: this.handleCompanyClick(company)
    }, /*#__PURE__*/React.createElement("img", {
      className: "company-select-list-item-colors",
      src: `${brandingURL}/companies/${company.id}/logos/colors`
    }), /*#__PURE__*/React.createElement("span", {
      className: "company-name"
    }, company.name), /*#__PURE__*/React.createElement("div", {
      className: "company-select-list-item-logo-container"
    }, /*#__PURE__*/React.createElement("img", {
      className: "company-select-list-item-logo",
      src: `${brandingURL}/companies/${company.id}/logos/primary`
    })))));
  }
}
//# sourceMappingURL=company-select.js.map